export { default as GDMNotifications } from './GDMNotifications';

export type { GDMNotificationsComponent } from './GDMNotifications.type';
